module.exports = __webpack_public_path__ + "static/img/movie-poster.8e1b514.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/movie-poster.jpg
// module id = 947
// module chunks = 173